import React, { FC, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Grid, Paper, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import classNames from 'classnames';
import moment from 'moment';

import { StatsGrouping } from 'api';
import { Charting, Numeric, Queries } from 'components';

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  },
  gutter: {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    borderTopLeftRadius: 4,
    borderTopRightRadius: 4,
  },
  small: {
    fontSize: theme.typography.pxToRem(12),
  },
  wrapper: {
    padding: 16,
    borderRight: `1px solid ${theme.custom.palette.grey3}`,
    borderBottom: `1px solid ${theme.custom.palette.grey3}`,
  },
  last: {
    borderRight: 0,
  },
}));

const Client: FC = () => {
  const classes = useStyles();
  const { t } = useTranslation();

  const [variables, setVariables] = useState({
    grouping: StatsGrouping.Year,
    value: moment().year(),
  });

  return (
    <Paper className={classes.root}>
      <div className={classes.gutter}>
        <Grid container alignItems="center" justify="space-around">
          <Grid item xs>
            <Typography color="inherit" variant="subtitle2">
              {t('components:myActivity')}
            </Typography>
          </Grid>
          <Grid item>
            <Charting.PeriodSelect
              variables={variables}
              onChange={changed => setVariables(changed)}
            />
          </Grid>
        </Grid>
      </div>
      <Queries.UserEngagement loader="none" {...variables}>
        {data => (
          <Grid container alignItems="center">
            <Grid item xs={4}>
              <div className={classes.wrapper}>
                <Typography align="center" className={classes.small}>
                  {t('common:post_plural')}
                </Typography>
                <Typography align="center" variant="subtitle2">
                  <Numeric value={data.posts} />
                </Typography>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classes.wrapper}>
                <Typography align="center" className={classes.small}>
                  {t('common:like_plural')}
                </Typography>
                <Typography align="center" variant="subtitle2">
                  <Numeric value={data.reactions} />
                </Typography>
              </div>
            </Grid>
            <Grid item xs={4}>
              <div className={classNames(classes.wrapper, classes.last)}>
                <Typography align="center" className={classes.small}>
                  {t('common:comment_plural')}
                </Typography>
                <Typography align="center" variant="subtitle2">
                  <Numeric value={data.comments} />
                </Typography>
              </div>
            </Grid>
          </Grid>
        )}
      </Queries.UserEngagement>
    </Paper>
  );
};

export default Client;
